(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mini-cart"]) return;
  try {
    
  setTimeout(function() {
 
}, 1000); 

  } catch(e) { console.error(e); }
})();
})();
